/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
import React from 'react'
import * as d3Color from 'd3-color'
import { ballRadiusFeet } from 'bam-node-baseball-savant/constants/ball'
import Color from '../../Utilities/Colors/ColorMap.ts'

import Legend from '../../Legend/Legend.tsx'
import Tooltip from '../../Tooltip/Tooltip.ts'

import setTextColor from '../../Utilities/Colors/TextColorBasedOnBackground.ts'
import { EVPData } from '../../schema/types.ts'
import {
    useChartOptions,
    usePixelPositions,
    useScales,
    useTooltip,
    useZoom,
} from '../../Context/ChartContext.tsx'

type PitchesProps = {
    onPitchClick: (event: React.MouseEvent, pitch: EVPData) => void
}

export default function Pitches({ onPitchClick }: PitchesProps) {
    const { settings, chartOptions } = useChartOptions()
    const { tooltipRef } = useTooltip()
    const { zoom } = useZoom()

    const isZoomed = zoom !== 1

    // let pitchData = RemoveBadPitchPoints(settings.data);
    const pitchData = settings.data

    const { xScale } = useScales()

    function handleMouseOver(event: React.MouseEvent, pitch: EVPData) {
        const tip = pitch.tooltip

        if (!isZoomed && tip && tooltipRef.current) {
            Tooltip(event, settings, tooltipRef.current, tip)
        }
    }

    function handleMouseOut(event: React.MouseEvent) {
        if (tooltipRef.current) {
            Tooltip(event, settings, tooltipRef.current)
        }
    }

    function handleClick(event: React.MouseEvent, pitch: EVPData) {
        if (settings.enableZoom) {
            onPitchClick(event, pitch)
            return
        }

        if (pitch.videoUrl) {
            window.open(pitch.videoUrl)
        }
    }

    // TODO handle relative size
    const fullBallRadius = Math.abs(xScale(ballRadiusFeet) - xScale(0))
    const strokeWidth = 1
    const ballRadius = fullBallRadius - strokeWidth / 2

    // TODO: We need to see where this chartOption actually is used
    // let radiusSize = 5

    // if (settings.shape === 'twitter') {
    //     radiusSize = 4
    // }

    // if (chartOptions.labelPitches && pitchData.length >= 1000) {
    //     radiusSize = 10
    // } else if (chartOptions.labelPitches && pitchData.length >= 100) {
    //     radiusSize = 8
    // } else if (chartOptions.labelPitches && pitchData.length >= 10) {
    //     radiusSize = 6
    // } else if (chartOptions.labelPitches && pitchData.length >= 1) {
    //     radiusSize = 5
    // }
    const filteredPitches = pitchData.filter((d) =>
        chartOptions.legendType === 'battedBallType'
            ? d.battedBallType !== null
            : d
    )

    const pixelPositions = usePixelPositions(filteredPitches)
    const { legendType } = chartOptions

    return (
        <>
            <g key="pitchChart" id="pitchChart">
                {filteredPitches.map((d, i) => {
                    // This seems like a bad API to stringify, but trying not to modify too much right now (Haha)
                    const stringValue = String(d[chartOptions.legendType])
                    const fillColor = Color(legendType, stringValue) || '#fff'

                    return (
                        <g
                            key={`g_pitch_key_${i}`}
                            // transform={`translate(${x(d)},${z(d)})`}
                            transform={`translate(${pixelPositions[i].x},${pixelPositions[i].y})`}
                            style={{ cursor: 'pointer' }}
                            onMouseOver={(evt) => handleMouseOver(evt, d)}
                            onMouseOut={handleMouseOut}
                            onClick={(evt) => handleClick(evt, d)}
                        >
                            <circle
                                key={`pitch_${i}`}
                                r={ballRadius}
                                opacity={chartOptions.opacity}
                                fill={fillColor}
                                // fill={Number(d.zone) < 10 ? 'red' : 'blue'}
                                stroke="black"
                                strokeWidth={strokeWidth}
                            />
                            {chartOptions.labelPitches ? (
                                <text
                                    className="pitch-label"
                                    key={`text_key_${i}`}
                                    textAnchor="middle"
                                    dominantBaseline="middle"
                                    dy={1} // nudge
                                    fill={setTextColor(
                                        d3Color.color(
                                            fillColor
                                        ) as d3Color.RGBColor
                                    )}
                                >
                                    {chartOptions.pitchNumberOverride
                                        ? d.illustrator_pitch_number
                                        : i + 1}
                                </text>
                            ) : null}
                        </g>
                    )
                })}
            </g>
            {chartOptions.legend ? (
                <Legend settings={settings} type={chartOptions.legendType} />
            ) : null}
        </>
    )
}
